import * as types from './action-types';

export const defaultState = {
    error: null,
    pullingCredit: false,
    creditReportSuccess: false,
    creditReportFailure: false,
    code: null,
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
    case types.PULL_CREDIT_RESET:
        return defaultState;
    case types.PULL_CREDIT_PENDING:
        return Object.assign({}, defaultState, {
            pullingCredit: true,
        });
    case types.PULL_CREDIT_FAILURE:
        return Object.assign({}, state, {
            error: action.error,
            pullingCredit: false,
            creditReportFailure: true,
            creditReportSuccess: false,
            code: action.error.code,
        });
    case types.PULL_CREDIT_SUCCESS:
        return Object.assign({}, state, {
            error: null,
            pullingCredit: false,
            creditReportFailure: false,
            creditReportSuccess: true,
            code: action.res.code,
        });
    default:
        return Object.assign({}, state);
    }
};

export default reducer;
